module.exports = __webpack_public_path__ + "static/media/digitXplus.0224fd4a.png";